import React, { useState, useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import _ from 'lodash';
const CompanyDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [company, , companyLoading] = useGet(`/companies/${id}`, true);

  const [postCompany, postedData, postingError, dataPosting] = usePatch(
    `/companies/${id}`
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();

  const [selectedImage, setSelectedImage] = useState(null);
  const handleFormSubmit = (event, errors, values) => {
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }

    const obj = _.omit({
      ...values,
    });
    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postCompany({ ...obj, image: _urls[0] });
      });
    } else {
      postCompany(obj);
    }
  };

  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Company has been updated successfully');
      history.push('/supplies/companies');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Company</h4>
                <Card>
                  <CardBody>
                    {companyLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <FormGroup>
                          <Label htmlFor='name'>Name</Label>
                          <AvField
                            name='name'
                            placeholder='Name'
                            type='text'
                            errorMessage='Enter Name'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='name'
                            value={company?.name}
                          />
                        </FormGroup>
                        <Row className='mb-3'>
                          <Col md={1}>
                            <img
                              src={company?.image}
                              className='rounded-circle avatar-sm card-img'
                            />
                          </Col>
                          <Col md={11}>
                            {' '}
                            <FormGroup>
                              <div className='custom-file'>
                                <CustomInput
                                  type='file'
                                  className='custom-file-input'
                                  id='image'
                                  accept='image/*'
                                  onChange={(e) => {
                                    setSelectedImage(e.target.files[0]);
                                  }}
                                />
                                <Label
                                  className='custom-file-label'
                                  htmlFor='image'
                                >
                                  {selectedImage
                                    ? selectedImage.name
                                    : 'Change Image'}
                                </Label>
                              </div>
                              {selectedImage && (
                                <span className='d-block font-size-20 text-danger text-right'>
                                  <i
                                    onClick={() => setSelectedImage(null)}
                                    style={{ cursor: 'pointer' }}
                                    className='ri-close-line'
                                  ></i>
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Update Company'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default CompanyDetails;
